// 存储公共信息
export default {
  source: 'wap',
  version: '4.1.4',
  clientId: 'pc',
};
